import { call, fork, put, take } from 'redux-saga/effects';
import * as actions from 'actions/cargoes/ldRates';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get Loading And Discharging
 * */
function* getLoadingAndDischarging() {
    const response = yield call(api.getLoadingAndDischarging);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_LOADING_AND_DISCHARGING.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_LOADING_AND_DISCHARGING.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetLoadingAndDischarging() {
    while (true) {
        yield take(actionTypes.GET_LOADING_AND_DISCHARGING.REQUEST);
        yield fork(getLoadingAndDischarging);
    }
}

/**
 * Update Loading And Discharging
 * */
function* updateLoadingAndDischarging(item) {
    const response = yield call(api.updateLoadingAndDischarging, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_LOADING_AND_DISCHARGING.SUCCESS,
            item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.UPDATE_LOADING_AND_DISCHARGING.FAILURE,
        errors: response.errors,
        item,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: response.item._id,
            autoDismiss: 2,
        },
    });
}

export function* watchUpdateLoadingAndDischarging() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_LOADING_AND_DISCHARGING.REQUEST);
        yield fork(updateLoadingAndDischarging, item);
    }
}

/**
 * Delete Loading And Discharging
 * */
function* deleteLoadingAndDischarging(item) {
    const response = yield call(api.deleteLoadingAndDischarging, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_LOADING_AND_DISCHARGING.SUCCESS,
            item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.DELETE_LOADING_AND_DISCHARGING.FAILURE,
        item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: response.item._id,
            autoDismiss: 2,
        },
    });

}

export function* watchDeleteLoadingAndDischarging() {
    while (true) {
        const { item } = yield take(actionTypes.DELETE_LOADING_AND_DISCHARGING.REQUEST);
        yield fork(deleteLoadingAndDischarging, item);
    }
}

export default [
    watchGetLoadingAndDischarging,
    watchUpdateLoadingAndDischarging,
    watchDeleteLoadingAndDischarging,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/ldRates.js